import { Link } from "@mui/material";
import { InfoIconPopover } from "components/InfoIconPopover";

type Subject = "chemical" | "component";

export function EhsFormDisabledReasonPopover({ subject }: { subject: Subject }) {
  return (
    <InfoIconPopover
      content={
        <>
          EHS Form is only editable for{" "}
          <Link
            href="https://www.epa.gov/epcra/what-reactive-and-non-reactive-solid-ehs"
            target="_blank"
            rel="noopener noreferrer"
          >
            reactive solids
          </Link>
          . This field requires a valid CAS number and the {subject} to be marked as EHS with a
          reactive solid classification.
        </>
      }
    />
  );
}
